import axios from 'axios';

export const apiClientes = axios.create({
  baseURL: process.env.REACT_APP_API_CLIENTES
});

export const apiSpmweb = axios.create({
  baseURL: process.env.REACT_APP_API_SPMWEB
});